(function ($) {
    var $el = $('[data-char-limit]');
    for (var i = 0; i < $el.length; i++) {
        // Check if each applicable div has a character count higher than its defined character limit
        if($($el[i]).text().length > $($el[i]).data('char-limit')) {
            // If it is, clip the text and append a 'Show more' button to the end of it
            clipText($($el[i]), $($el[i]).data('char-limit'));
            // Add a cick event handle to toggle hidden content
            $($el[i]).find('.c-char-limit--btn').on('click', function() {
                $(this).parents('[data-char-limit]').find('.c-char-limit').toggleClass('-visible');
            });
        }
    }
}(jQuery));

function clipText($el, charLimit) {
    var hidden = $($el).text().substring(charLimit);
    // Build markup for hidden items and toggle button. Hidden items shown by toggling -visible class
    $($el).html($($el).text().substring(0, charLimit) +
    `<span class="c-char-limit -visible">...</span>
    <span class="c-char-limit">` + hidden + `</span>
    <button type="button" class="c-btn c-btn--link c-char-limit--btn">
        Show 
        <span class="c-char-limit -visible">more</span>
        <span class="c-char-limit">less</span>
    </button>`);
}



// WEBPACK FOOTER //
// ./src/app/components/char-limit/char-limit.js